<template>
  <div class="big">
    <div class="page_title flex between">
      <span>{{title}}</span>
      <span>
        <el-button type="primary"
                   style="width:90px"
                   @click="submitForm('ruleForm')">保存</el-button>
        <el-button plain
                   style="width:90px"
                   @click="back">返回</el-button>
      </span>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="120px"
                 class="demo-ruleForm"
                 style="text-align:left">
          <div class="flex between"
               style="width:700px;">
            <el-form-item label="剂型"
                          prop="drug_type_name">
              <el-input v-model="ruleForm.drug_type_name"
                        maxlength="20"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="剂型分类"
                          prop="drug_type_pid">
              <el-select v-model="ruleForm.drug_type_pid"
                         placeholder="请选择">
                <el-option v-for="item in typeList"
                           :key="item.drug_type_pid"
                           :label="item.drug_type_pid_name"
                           :value="item.drug_type_pid"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="flex"
               style="width:80%;">
            <el-form-item label="患者端取药时是否显示剂型介绍"
                          label-width="290px"
                          prop="is_show_desc">
              <el-radio-group v-model="ruleForm.is_show_desc">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="ruleForm.is_show_desc==1">
              <el-form-item label="标题"
                            label-width="60px"
                            prop="title_desc">
                <el-input v-model="ruleForm.title_desc"
                          maxlength="10"
                          clearable></el-input>
              </el-form-item>

              <el-form-item label="链接"
                            label-width="60px"
                            prop="desc_url">
                <el-input v-model="ruleForm.desc_url"
                          clearable></el-input>
              </el-form-item>
            </template>

          </div>

          <el-form-item label="备注"
                        style="width:700px;">
            <el-input v-model="ruleForm.remark"></el-input>
          </el-form-item>
          <div style="text-align:left;font-size:15px;font-weight:700;padding-left:24px;margin:20px 0 10px">开放终端</div>
          <el-form-item label="歧黄医官APP"
                        prop="doctor_app">
            <el-radio-group v-model="ruleForm.doctor_app">
              <el-radio :label="1">开放</el-radio>
              <el-radio :label="2">不开放</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="云诊所"
                        prop="clinic_web">
            <el-radio-group v-model="ruleForm.clinic_web">
              <el-radio :label="1">开放</el-radio>
              <el-radio :label="2">不开放</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="医生拍方购药"
                        prop="platform_phone">
            <el-radio-group v-model="ruleForm.platform_phone">
              <el-radio :label="1">开放</el-radio>
              <el-radio :label="2">不开放</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="平台按方购药"
                        prop="platform_agree">
            <el-radio-group v-model="ruleForm.platform_agree">
              <el-radio :label="1">开放</el-radio>
              <el-radio :label="2">不开放</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '添加剂型',
      typeList: [],
      ruleForm: {
        drug_type_name: '',
        drug_type_pid: '',
        doctor_app: 1,
        clinic_web: 1,
        platform_phone: 1,
        platform_agree: 1,
        remark: '',
        is_show_desc: 0,
        title_desc: '',
        desc_url: ''
      },
      rules: {
        drug_type_name: [
          { required: true, message: '请输入剂型名称', trigger: 'blur' }
        ],
        drug_type_pid: [
          { required: true, message: '请选择剂型分类', trigger: 'change' }
        ],
        doctor_app: [
          { required: true, message: '请设置开放平台', trigger: 'change' }
        ],
        clinic_web: [
          { required: true, message: '请设置开放平台', trigger: 'change' }
        ],
        platform_phone: [
          { required: true, message: '请设置开放平台', trigger: 'change' }
        ],
        platform_agree: [
          { required: true, message: '请设置开放平台', trigger: 'change' }
        ],

        is_show_desc: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        title_desc: [{ required: true, message: '请输入', trigger: 'blur' }],
        desc_url: [{ required: true, message: '请输入', trigger: 'blur' }]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取详情
    getDetail() {
      let info = JSON.parse(this.$route.query.info);
      this.ruleForm = {
        drug_type_name: info.drug_type_name,
        drug_type_pid: info.drug_type_pid,
        doctor_app: info.doctor_app,
        clinic_web: info.clinic_web,
        platform_phone: info.platform_phone,
        platform_agree: info.platform_agree,
        remark: info.remark,
        drug_type: info.drug_type,
        is_show_desc: info.is_show_desc,
        title_desc: info.title_desc,
        desc_url: info.desc_url
      };
    },
    //获取剂型分类
    getTypeList() {
      this.axios.post('platform/Drugtype/getDrugTypePidList').then((res) => {
        this.typeList = res.data.list;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          if (this.$route.query.info) {
            this.axios
              .post('platform/Drugtype/editDrugType', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('修改成功');
                  history.back();
                }
              });
          } else {
            this.axios
              .post('platform/Drugtype/addDrugType', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('添加成功');
                  history.back();
                }
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    back() {
      history.back();
    }
  },

  created() {
    if (this.$route.query.info) {
      this.title = '编辑剂型';
      this.getDetail();
    }
    this.getTypeList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
